<template>
  <div
    class="checkbox-input"
    :class="{
      'checkbox-input--vertical': vertical,
      'checkbox-input--icon-box': radioStyle === 'icon-box',
      'checkbox-input--box': radioStyle === 'box',
      'checkbox-input--box-small': radioStyle === 'box-small',
      'checkbox-input--box-grid': radioStyle === 'box-grid',
      'checkbox-input--default': radioStyle === 'default',
      'checkbox-input--has-label': labelStyle !== 'hidden',
      'checkbox-input--radio': radioStyle === 'default'
    }"
  >
    <template v-if="labelStyle !== 'hidden'">
      <p class="title title--6 half-spacing">
        {{ label }}
        <span
          v-if="showAsOptional && !validations.required"
          class="gray regular smaller"
        >
          (Optional)
        </span>
      </p>
    </template>

    <div class="checkbox-input__options">
      <div
        v-for="(option, index) in options"
        :key="option.value"
        class="checkbox-input__option"
      >
        <input
          v-if="index === 0"
          :id="name + index"
          v-model="val"
          :disabled="option.disabled"
          :name="name"
          :value="option.value"
          class="checkbox-input__input"
          type="radio"
          @click="optionClickHandler(option)"
        >
        <input
          v-else
          :id="name + index"
          v-model="val"
          :disabled="option.disabled"
          :name="name"
          :value="option.value"
          class="checkbox-input__input"
          type="radio"
          @click="optionClickHandler(option)"
        >
        <label
          :for="name + index"
          class="checkbox-input__label"
        >
          <div
            v-if="option.icon && radioStyle === 'icon-box'"
            class="checkbox-input__icon"
          >
            <span :class="`icon icon--medium fas primary ${option.icon}`" />
          </div>
          <span class="checkbox-input__label-text">
            <span
              v-if="option.icon && radioStyle === 'box'"
              :class="`icon icon--bigger ${option.icon}`"
            />
            <template v-else-if="option.display">
              {{ option.display }}
            </template>

            <span
              v-if="option.subDisplay"
              class="checkbox-input__label-sub-text"
            >
              {{ option.subDisplay }}
            </span>
          </span>
        </label>
      </div>
    </div>

    <input-error :error="errorMessage ? 'An option must be selected.' : null" />
  </div>
</template>



<script>
  import { computed, watch } from 'vue';
  import { useField } from 'vee-validate';


  export default {
    name: 'RadioInput',

    props: {
      allowUncheck: {
        type: Boolean,
        default: false
      },

      label: {
        type: String,
        required: true
      },

      labelStyle: {
        type: String,
        default: ''
      },

      name: {
        type: String,
        required: true
      },

      options: {
        type: Array,
        required: true
      },
      // [
      //   {
      //     value: string | number | boolean,
      //     display: string,
      //     subDisplay: [string],
      //     disabled: [boolean],
      //     icon: [string]
      //   }
      // ]

      radioStyle: {
        type: String,
        default: 'default'
      },
      // 'box' | 'box-small' | 'icon-box' | 'default'

      showAsOptional: {
        type: Boolean,
        default: false
      },

      validations: {
        type: Object,
        default() {
          return {};
        }
      },

      modelValue: {
        type: [String, Number, Boolean],
        default: null
      },

      vertical: {
        type: Boolean,
        default: false
      }
    },

    // VeeValidate 4 requires the Composition API to register a field with the parent form context.
    // setup() is used exclusively for that purpose — all other component logic
    // remains in the Options API below.
    // Exposes: errorMessage (reactive validation error string, undefined when valid)
    // Note: handleChange is used internally by the watch() below and is not exposed.
    setup(props) {
      const rules = computed(() => props.validations);

      const { errorMessage, handleChange } = useField(() => props.name, rules, {
        initialValue: props.modelValue,
        label: props.label
      });

      watch(() => props.modelValue, handleChange);

      return { errorMessage };
    },

    computed: {
      val: {
        get() {
          return this.modelValue;
        },

        set(newValue) {
          this.$emit('update:modelValue', newValue);
        }
      }
    },

    methods: {
      optionClickHandler(option) {
        if (this.allowUncheck && option.value === this.modelValue) {
          this.$emit('update:modelValue', null);
        }
      }
    }
  };
</script>
